import React, { useCallback, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';
import { NotificationStyles } from './Styled'
import { Button } from 'components/Form';
import { getItem } from 'config/storage';

const BottomNotification = (props) => {
  const [open, setOpen] = useState(true);

  const { title, description, storageKey, actionLabel } = props

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const approveMessage = useCallback(() => {
    localStorage.setItem(storageKey, true)
    setOpen(false);
  }, [])

  return (
    <NotificationStyles>
      <Snackbar
        open={!getItem(storageKey) && open}
        autoHideDuration={null}  // הודעה שלא תסתיים אוטומטית
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}  // מיקום ההודעה
        onClose={handleClose}
      >
        <Alert icon={false} onClose={handleClose} sx={{ width: '100%' }}>
          <div className='title'>
            {title}
          </div>
          <div className='description'>
            {description}
          </div>
          <div className='wrap-approved-button'>
            <div className='approved-button'>
              <Button size="small" className="solid-round" color="secondary" label={actionLabel} action={approveMessage} />
            </div>
          </div>
        </Alert>
      </Snackbar>
    </NotificationStyles>
  );
};

export default BottomNotification;
